import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Select,
  MenuItem,
  ListItemText,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/AddVehicleDialog.css";
import { VEHICLE_TYPE } from "../../utils/constants";

const AddVehicleDialog = ({
  open,
  onClose,
  tripPhase,
  vehicleAdded,
  setVehicleAdded,
}) => {
  const [vehicleMakeModel, setVehicleMakeModel] = useState("");
  const [vehicleRegistration, setVehicleRegistration] = useState("");
  const [vehicleDriverName, setVehicleDriverName] = useState("");
  const [selectedVehicleType, setSelectedVehicleType] = useState("");

  const handleAddVehicle = () => {
    const vehicalData = {
      driverName: vehicleDriverName,
      vehicleName: vehicleMakeModel,
      escortVehicleType: selectedVehicleType,
      licensePlateNumber: vehicleRegistration,
      tripPhase: tripPhase,
    };
    setVehicleAdded([...vehicleAdded, vehicalData]);
    clearData();
    onClose();
  };

  const handleVehicleMakeModelChange = (event) => {
    setVehicleMakeModel(event.target.value);
  };

  const handleVehicleRegistrationChange = (event) => {
    setVehicleRegistration(event.target.value);
  };

  const handleVehicleDriverNameChange = (event) => {
    setVehicleDriverName(event.target.value);
  };

  const handleVehicleTypeToggle = (event) => {
    setSelectedVehicleType(event.target.value);
  };

  const clearData = () => {
    setVehicleMakeModel("");
    setVehicleRegistration("");
    setVehicleDriverName("");
    setSelectedVehicleType("");
  };

  const isValidForAdd = () => {
    return (
      vehicleMakeModel === "" ||
      vehicleRegistration === "" ||
      vehicleDriverName === "" ||
      selectedVehicleType === ""
    );
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "add-vehicle-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined className="add-vehicle-dialog-close" onClick={onClose} />
        <div className="add-vehicle-dialog-content">
          <div className="add-vehicle-dialog-title">Add Vehicle</div>
          <div className="add-vehicle-input-container">
            <label>Vehicle Type</label>
            <Select
              className="add-vehicle-select-container"
              value={selectedVehicleType}
              onChange={handleVehicleTypeToggle}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return <span style={{ color: "#696969" }}>Select</span>;
                }
                return VEHICLE_TYPE.find((type) => type.value === selected)
                  ?.name;
              }}
            >
              {VEHICLE_TYPE.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  <ListItemText primary={type.name} />
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className="add-vehicle-input-container">
            <label>Make and Model of the Vehicle</label>
            <input
              className="add-vehicle-input"
              name="profile-registration-number"
              value={vehicleMakeModel}
              placeholder="BMW X1 D Drive"
              onChange={handleVehicleMakeModelChange}
            />
          </div>
          <div className="add-vehicle-input-container">
            <label>Registration Number</label>
            <input
              className="add-vehicle-input"
              name="profile-registration-number"
              value={vehicleRegistration}
              placeholder="Enter here"
              onChange={handleVehicleRegistrationChange}
            />
          </div>
          <div className="add-vehicle-input-container">
            <label>Driver Name</label>
            <input
              className="add-vehicle-input"
              name="profile-registration-number"
              placeholder="Enter here"
              value={vehicleDriverName}
              onChange={handleVehicleDriverNameChange}
            />
          </div>

          <Button
            variant="contained"
            onClick={handleAddVehicle}
            disabled={isValidForAdd()}
          >
            Add
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddVehicleDialog;
